import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { CyclistService } from 'src/app/services/cyclist.service';
import { UserService } from 'src/app/services/user.service';
import { HelpersService } from 'src/app/services/helpers.service';
import { MessageService } from 'primeng/api';
import { CollectionsService } from '../../../../../services/collections.service';

@Component({
  selector: 'app-workshop-jobcard-edit-customer',
  templateUrl: './workshop-jobcard-edit-customer.component.html',
  styleUrls: ['./workshop-jobcard-edit-customer.component.scss'],
  providers: [MessageService]
})
export class WorkshopJobcardEditCustomerComponent {

  @Input() jobcard: any;
  @Output() customerSelected = new EventEmitter<any>();

  public customer: any = {};
  public originalCustomer: any = {};
  public updating: boolean = false;
  public busy: boolean = false;


  public partner: any;
  public addressOptions: any;
  public collectionAddrssLoading: boolean;
  public addresses = [];
  public addressSearch: any;
  public fullAddress: string = "";
  public showAddressDetails: boolean = false;
  public showCustomerDetails: boolean = true;
  public address: any = {};
  public addManually: boolean = true;
  public street_no: string
  public street_address: string
  public city: string
  public country: string
  public postal_code: string
  public editing: boolean = false;
  public editingAddress: any = {};

  constructor(
    public activeModal: NgbActiveModal,
    private translate: TranslateService,
    private cyclistService: CyclistService,
    private helpersService: HelpersService,
    private userService: UserService,
    private messageService: MessageService,
    private collectionsService: CollectionsService,
  ) {
    this.partner = this.helpersService.getPartnerData();
  }

  ngOnInit() {
    if (this.customer) {
      this.originalCustomer = JSON.parse(JSON.stringify(this.customer));
      this.customer = JSON.parse(JSON.stringify(this.customer));
    }
  }

  setUpdating(value: boolean) {
    this.busy = !value;
  }

  isValidCustomer(): boolean {
    return this.customer && (this.cyclistService.isValidPhoneNumber(this.customer.PhoneNumber) || this.cyclistService.isValidEmail(this.customer.Email));
  }

  updateCustomer() {
    if (this.busy)
      return;
    if (this.isValidCustomer()) {
      this.updating = true;
      var data = {
        ID: this.customer.ID,
        Name: this.customer.Name,
        Surname: this.customer.Surname,
        Email: this.customer.Email,
        PhoneNumber: this.customer.PhoneNumber,
        PartnerID: this.helpersService.getPartnerId(),
        ExternalID: this.customer.ExternalID || 0,
        OriginalUser: this.originalCustomer
      }
      this.userService.updateCustomer(data).subscribe((response) => {

        if(response.Data.ID === 0) {
          this.linkStorageAccount(response.Data);
          return;
        }else{
          this.jobcard.customer = {
            ID: response.Data.ID,
            Name: response.Data.CustomerName,
            Surname: response.Data.CustomerSurname,
            Email: response.Data.CustomerEmail,
            PhoneNumber: response.Data.CustomerMobile,
            ExternalID: response.Data.ExternalID || 0
          };

          this.updating = false;
          this.activeModal.close({ ...this.jobcard });
        }
      }, (error) => {
        this.updating = false;
        console.error('Error updating customer:', error);
        if (error && error.error?.error === "CUSTOMER_EXISTS") {
          this.messageService.add({ life: 5000, summary: this.translate.instant('bikeshop.workshop.jobcard.customer.edit_customer_error.customer_exists') });
        } else {
          this.messageService.add({ life: 5000, summary: this.translate.instant('bikeshop.workshop.jobcard.customer.edit_customer_error.general_error') });
        }

      });
    } else {
      this.activeModal.close({ ...this.jobcard });
    }
  }

  linkStorageAccount(customer) {
    this.cyclistService.linkCyclists(this.helpersService.getPartnerId(), customer).subscribe((response) => {
      if (response && response.Data && response.Data.length > 0) {
        this.jobcard.customer = {
          ID: response.Data[0].ID,
          Name: response.Data[0].CustomerName,
          Surname: response.Data[0].CustomerSurname,
          Email: response.Data[0].CustomerEmail,
          PhoneNumber: response.Data[0].CustomerMobile,
          ExternalID: response.Data[0].ExternalID || 0
        };
        this.activeModal.close({ ...this.jobcard });
      } else {
        console.error('Error linking customer:', response);
      }
    }, err => {

    });
  }

  removeCustomer() {
    this.activeModal.close({ action: 'delete', customer: this.customer });
  }

  @HostListener('document:keydown.enter', ['$event'])
  handleEnter(event: KeyboardEvent) {
    this.updateCustomer();
  }

  showSteps(step) {
    switch (step) {
      case "addressDetails":
        this.showAddressDetails = true;
        this.showCustomerDetails = false;
        break;
      case "customerDetails":
        this.showAddressDetails = false;
        this.showCustomerDetails = true;
        break;
    }
  }

}
